<div class="blocco-testo">
  <h3 class="titolo" *ngIf="titolo">{{titolo}}</h3>
  <div class="testo" *ngIf="testo" [innerHTML]="testo"></div>
</div>
